import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Divider,
  Typography,
} from "@mui/material";
import React from "react";
import { AdminListContext } from "../context/adminListContext";
import AdminProps from "../interface/adminProps";

const RevokeAdminDialog = (): React.JSX.Element => {
  const {
    revokeAdmin,
    setRevokeAdmin,
    removeAdminRights,
  }: {
    revokeAdmin: AdminProps | null;
    setRevokeAdmin: React.Dispatch<React.SetStateAction<AdminProps | null>>;
    removeAdminRights: (userId: number) => Promise<void>;
  } = React.useContext(AdminListContext);

  if (!revokeAdmin) return <React.Fragment />;

  return (
    <Dialog
      open
      maxWidth="sm"
      onClose={() => setRevokeAdmin(null)}
      aria-labelledby="revoke-admin-rights"
    >
      <DialogTitle id="revoke-admin-rights">
        Admin-Rechte entziehen
      </DialogTitle>

      <Divider />

      <DialogContent>
        <DialogContentText>
          Sollen diesem Nutzer die Admin-Rechte wirklich entzogen werden?
        </DialogContentText>

        <Box
          sx={{
            backgroundColor: "#eeeeee",
            borderRadius: 2,
            p: 2,
            my: 2,
          }}
        >
          <Typography
            variant="h6"
            color="text.primary"
            sx={{ fontWeight: "bold" }}
          >
            {revokeAdmin.firstName} {revokeAdmin.lastName}
          </Typography>
          <Typography variant="body2" color="text.primary">
            {revokeAdmin.email}
          </Typography>
        </Box>

        <DialogContentText>
          {revokeAdmin.isCoach
            ? "Der Zugang bleibt bestehen, der Nutzer arbeitet danach wieder als Coach."
            : "Der Zugang bleibt bestehen, der Nutzer sieht danach wieder die Ansicht für Teilnehmende."}
        </DialogContentText>
      </DialogContent>

      <Divider />

      <DialogActions
        sx={{
          display: "flex",
          justifyContent: "space-between",
          padding: 2,
        }}
      >
        <Button onClick={() => setRevokeAdmin(null)} color="primary">
          Abbrechen
        </Button>

        <Button
          onClick={() => removeAdminRights(revokeAdmin.userId)}
          variant="contained"
          color="error"
        >
          Rechte entziehen
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default RevokeAdminDialog;
